import { isEmpty } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Dialog, Form, Input, MessagePlugin, Select, Tooltip } from 'tdesign-react';
import { saveNewStencil } from '@/services/execVariableService';
import PermWrapper from '@/components/PermWrapper';
import { toTsOptions } from '@/utils/common';

const { FormItem } = Form;

function SaveAsTemplate({ variables, cluster }) {
  const [visible, setVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [form] = Form.useForm();

  const ipVariables = useMemo(() => {
    return variables.filter((item) => item.variableLevel === 1);
  }, [variables]);

  const showModal = () => {
    if (isEmpty(cluster)) {
      MessagePlugin.warning('请先选择集群');
      return;
    }
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        await saveNewStencil({
          ...fields,
          clusterId: cluster.id,
          ipKeyList: fields.ipKeyList?.map((item) => {
            const [key, defaultValue] = Object.entries(item)[0];
            return {
              key,
              defaultValue,
            };
          }),
        });
        MessagePlugin.success('操作成功！');
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  useEffect(() => {
    if (!visible) {
      form.reset();
    }
  }, [visible, form]);

  return (
    <>
      <PermWrapper resource='pulsar:exec:variable:save'>
        {' '}
        <Tooltip content='将当前变量保存为新的变量模板并应用'>
          <Button onClick={showModal}>另存为</Button>
        </Tooltip>
      </PermWrapper>
      <Dialog
        visible={visible}
        header='另存为'
        onConfirm={() => form.submit()}
        confirmBtn={{ loading: submitting, content: '确定' }}
        onClose={() => handleClose()}
      >
        <Form form={form} style={{ width: '90%' }} onSubmit={handleSubmit}>
          <FormItem name='stencilName' label='模板名称' rules={[{ required: true }]}>
            <Input />
          </FormItem>
          {ipVariables.map((ipVar, index) => (
            <FormItem
              name={['ipKeyList', index, ipVar.key]}
              key={index}
              label={ipVar.key}
              rules={[{ required: true, message: '请选择' }]}
            >
              <Select
                options={toTsOptions(
                  ipVar.hostKeyInfos?.map((item) => ({
                    label: item.ip,
                    value: item.currentValue,
                  })),
                )}
              />
            </FormItem>
          ))}
        </Form>
      </Dialog>
    </>
  );
}

export default connect((state) => ({
  variables: state.execVariable.variables || [],
  cluster: state.execVariable.cluster,
}))(SaveAsTemplate);
